module.exports = __webpack_public_path__ + "static/img/logo_black.c180e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_black.png
// module id = 1657
// module chunks = 0